<template>
	<div class="" @click="$sidebar.displaySidebar(false)">			
		<div class="row ">
            <div class="col-xl-8 mb-5 mb-xl-0">
                <div class="card shadow">
                    <div class="card-body">
 						<h4 class="mb-3">新規サイト登録</h4>
						<div class="loading"  v-show="loading">読み込み中...</div>

						<div>
							
							<div class="form-group" v-bind:class="{  'text-danger has-error': errors.site_name_jp }">
                                  <label for="site_name_jp">サイト名<span class="badge badge-required">必須</span></label>
                                  <input type="text" placeholder="例：Push L" v-model="site_name_jp" class="form-control" value="" name="site_name_jp" id="site_name_jp" />
                                    <p v-for="(error,key) in errors.site_name_jp" :key="key" class="error-text" >{{error}}</p>
                              
                              </div>

							  <div class="form-group" v-bind:class="{  'text-danger has-error': errors.site_domain }">
                                  <label for="site_domain">契約ドメイン<span class="badge badge-required">必須</span></label>
                                  <input type="text" placeholder="例：pushl.info" v-model="site_domain" class="form-control" value="" name="site_domain" id="site_domain" />
                                    <p v-for="(error,key) in errors.site_domain" :key="key" class="error-text" >{{error}}</p>
                              </div>

							<div class="form-group" v-bind:class="{  'text-danger has-error': errors.utcoffset }">
							<label >タイムゾーン<span class="badge badge-required">必須</span></label>
						<div class="input-group" >
						<select  class="" v-model="timezoneSelected" >
							<option  value="">--</option>
							<option v-for="(n,key) in allTimezones" :key="key" :value="n.offset + '--' + n.jp_text + '--' + n.en_text" :selected="n.en_text == 'Asia/Tokyo'">(UTC {{n.offset }}) {{ n.jp_text }}</option>
						</select>
						</div>
						<p v-for="(error,key) in errors.utcoffset" :key="key" class="error-text" >{{error}}</p>
						
						</div>

						<div class="form-group" >
                                  <label>契約プラン<!--<span class="badge badge-required">必須</span>--></label>
                                  <div> <span class="plan-ttl">{{planName}}</span></div>
                                   
                              </div>


						<div v-if="isInitialization" class="btn-wrap form-group text-center">
							<button class="btn btn-primary btn-back-form" @click="goback">戻る</button>
							<button class="btn btn-primary btn-next-form" @click="send">登録確認へ</button>
						</div>

						<div v-else class="btn-wrap form-group text-center">
							<a class="btn btn-primary" href="javascript:history.back()">一覧に戻る</a>
							<button  class="btn btn-primary" @click="send"  :disabled="loading" >登録する</button>
                        </div>
							
						</div>
					</div>
                </div>
            </div>

		</div>
	</div>
</template>

<script>

export default {
	components: { },
	props: ['sitePlan'],
	data() {
		return {
			// Our data object that holds the Laravel paginator data
			siteId:null,
			site_name_jp:"",
			siteList:{},
			allTimezones:{},
			site_domain:"",
			sitePlanUrl:"",
			planName: "",
			planIdentifier: "",
			timezoneSelected: "",
			errors: {},
			loading: false,
			isInitialization:false
		}
	},

	mounted() {
		// Fetch initial results
		this.siteId = window.PushL.site_id;
		//this.sitePlanUrl = `/site/${this.siteId}/changeplan`;
		this.planName = "Free";
		this.allTimezones = this.getTimezone();
		this.isInitialization = window.initial_setup ? window.initial_setup : false
		
	},

	methods: {
		async getTimezone () {
			const url = '/json/timezones.json';
			const params = { };
			axios.get(url, params)
			.then(response => {
				this.allTimezones = response.data;
			});
		},
		goback() {
			window.stepperForm.previous()
		},
		send() {
			this.loading = true;
			this.isSend = 0;
			this.errors = {};
			let url = this.site_domain;
			const originalUrl = url;
			if (!/^https?:\/\//i.test(url)) {
				url = 'https://' + url;
			}
			
			axios.post(`/site/store`, {
				utcoffset : this.timezoneSelected,
				site_name_jp : this.site_name_jp,
				site_domain : url,
				plan_identifier:this.planIdentifier,
				is_validation: this.isInitialization ? 1 : 0
			}).then(response => {
				this.loading = false;
				if(this.isInitialization ) {
					//this.$emit('tempSiteData', response.data.tempSiteData);
					tempSiteData = response.data.tempSiteData;
					const parts = (this.timezoneSelected).split("--");
					tempSiteData['site_domain'] = url;
					tempSiteData['original_url'] = originalUrl;
					tempSiteData['timezone'] = '(UTC' + parts[0]  +') ' + parts[1];
					window.stepperForm.next()
				} else {
					this.$toast(response.data.info, {
						toastClassName: "toaster"
					}) 
				}
			}).catch(error => {
				console.log(error)
				if (error.response.status === 422) {
					this.errors = error.response.data.errors || {};
					this.loading = false;
					if(error.response.data.info) {
						this.$toast(error.response.data.info, {
							toastClassName: "toaster"
						}) 
					}
				//this.info = error.response.data.info
				} else if (error.response.status === 419) {
				alert("ページセッション切りましたので、更新できませんでした。ページをリロードしてください")
				}
			});
		}
	}
}
</script>

<style scoped>
.selected-option {
	display:block;
	min-width:200px;
}
.copybutton {
	background-color:transparent;
	border:0;
	outline:0;
	cursor:pointer;
	opacity:1;
	position:absolute;
	top: 10px;
	right:10px;
	z-index:9;
	border-radius:24px;
}
.button-tooltip-container {
    display: flex;
    align-items: center;
    margin-top: 16px;
    min-height: 30px;
}

#custom-tooltip {
    display: none;
    margin-left: 40px;
    padding: 5px 12px;
	background-color: rgba(94,118,228, .9);
    border-radius: 4px;
    color: #fff;
	position:absolute;
	right:10px;
	top: -40px;
}

textarea {
	width: 100%;
	height: 200px;
	resize: none;
	border:1px solid #CDD3D9;
}
.opt-val {
	display:block;
	margin-top: 10px;
}

.card {
	max-width: 1024px;
}

.card-body {
	padding: 1.5rem;
}
.plan-ttl {
	display:inline-block;
	margin-right: 20px;
}
</style>